export default __webpack_public_path__ + "static/media/Aura-Egg__89.4d0a1597.png";